<template>
  <div class="details-component">
    <div class="details-component__header">
      <h1>{{ $t('maps.new_map')}}</h1>
    </div>
    <div class="details-component__content">
      <form class="form fixed-form">

        <table class="details-table no-col-padding edit-table fixed-table label-col-wide-150">

          <tr class="details-table__row" :class="{'details-table__row_error' : errors.has('name') }">
            <td class="details-table__col details-table__col_label">
              <label for="name" class="form__label">{{ $t('maps.name')}}</label>
            </td>
            <td class="details-table__col">
              <input type="text" class="form__input" v-model.trim="form.name" id="name"
                     v-validate data-vv-rules="required|max:255" name="name"/>
              <tooltip v-show="errors.has('name:required')" class="form__validation">{{ $t('errors.field_required') }}</tooltip>
              <tooltip v-show="errors.has('name:min')" class="form__validation">{{ $t('errors.field_min') }}</tooltip>
            </td>
          </tr>

          <tr class="details-table__row" :class="{'details-table__row_error' : errors.has('style')}">
            <td class="details-table__col details-table__col_label">
              <label for="style" class="form__label">{{ $t('maps.map_style')}}</label>
            </td>
            <td class="details-table__col landlord__name">
              <el-select name="style"
                         v-model="form.style"
                         :placeholder="$t('maps.choose_a_maps_style')"
                         @change="styleChange"
                         >
                <el-option
                        v-for="s in mapStyles"
                        :key="s.id"
                        :label="s.name"
                        :value="s.id">
                </el-option>
              </el-select>
              <tooltip v-show="errors.has('style')" class="form__validation">{{ $t('errors.style_field_required') }}</tooltip>
            </td>
          </tr>

          <tr class="details-table__row auto-height with-border" :class="{'details-table__row_error' : errors.has('zone')}">
            <td class="details-table__col details-table__col_label">
              <label for="zones" class="form__label">{{ $tc('common.zones', zones.items ? zones.items.length : 0) }}</label>
            </td>
            <td class="details-table__col txt-to-left" colspan="2">
              <el-select
                      class="fit-to-parent"
                      v-model="form.zones"
                      multiple
                      filterable
                      :placeholder="$t('maps.add_zones_to_the_map')">
                <el-option
                        v-for="zone in zones.items"
                        :key="zone.id"
                        :label="`${zone.code ? zone.code : zone.address}`"
                        :value="zone.id">
                </el-option>
              </el-select>
              <tooltip v-show="errors.has('zone')" class="form__validation">{{ $t('errors.zone_required') }}</tooltip>
            </td>
          </tr>

          <tr class="details-table__row" :class="{'details-table__row_error' : errors.has('zoom')}">
            <td class="details-table__col details-table__col_label">
              <label for="zoom" class="form__label">{{ $t('maps.zoom') }}</label>
            </td>
            <td class="details-table__col">
              <el-input-number v-model="form.zoom" :min="1" :max="20" @change="zoomChange"></el-input-number>
            </td>
          </tr>

          <tr class="details-table__row" :class="{'details-table__row_error' : errors.has('longitude')}">
            <td class="details-table__col details-table__col_label">
              <label for="longitude" class="form__label">{{ $t('maps.longitude') }}</label>
            </td>
            <td class="details-table__col">
              <input type="number" class="form__input"
                     name="longitude"
                     id="longitude"
                     v-model="form.center[0]"
                     />
            </td>
          </tr>

          <tr class="details-table__row" :class="{'details-table__row_error' : errors.has('latitude')}">
            <td class="details-table__col details-table__col_label">
              <label for="latitude" class="form__label">{{ $t('maps.latitude') }}</label>
            </td>
            <td class="details-table__col">
              <input type="number" class="form__input"
                     name="latitude"
                     id="latitude"
                     v-model="form.center[1]"
              />
            </td>
          </tr>

          <tr class="details-table__row">
            <td class="details-table__map-container" colspan="2">
              <div id='map-dom'></div>
            </td>
          </tr>
        </table>

        <div class="form__buttons buttonset">
          <router-link v-if="isNew" :to="{ name: 'maps' }" class="buttonset__button btn btn--secondary">
            {{ $t('common.discard') }}
          </router-link>
          <router-link v-else :to="{ name: 'maps', params: { id: $route.params.id} }" class="buttonset__button btn btn--secondary">
            {{ $t('common.discard') }}
          </router-link>
          <button type="submit" class="buttonset__button btn btn--main" v-on:click.prevent.stop="onSubmit()">
            {{ $t('common.save') }}
          </button>
        </div>

        <WarningModal v-if="mapsError" @close="closeWarningModal()">
          <h1 slot="header">{{ $t('common.error') }}</h1>
          <p slot="body">{{ warningModalBody }}</p>
        </WarningModal>


      </form>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';
import * as mTypes from 'store/mutation-types';
import 'styles/blocks/details.scss';
import Tooltip from 'common/Tooltip';
import WarningModal from 'common/WarningModal';

export default {
  components: {
    Tooltip,
    WarningModal,
  },
  created() {
    this.initData();
    this.fetchMap();
  },
  watch: {
    $route: 'fetchMap',
  },
  computed: {
    isNew() {
      return !this.$route.params.id;
    },
    ...mapGetters({
      map: 'maps/map/mapItem',
      mapStyles: 'maps/map/mapStyles',
      mapsError: 'maps/map/error',
      zones: 'maps/zones/zones',
    }),
  },
  methods: {
    fetchMap() {
      if (this.$route.params.id && this.user.data) {
        this.$store.dispatch('maps/map/fetch', { id: this.$route.params.id, user: this.user }).then(() => {
          this.form = this.map;
          this.initMap();
        });
      } else {
        this.form = {
          name: '',
          style: 'klokantech-basic',
          center: [0, 0],
          zoom: 10,
          zones: [],
        };
        this.$store.commit(`maps/map/${mTypes.CLEAR_STATE}`);
        this.initMap();
        this.initPosition();
      }
    },
    initMap() {
      Vue.nextTick(() => {
        this.mapInstance = new mapboxgl.Map({
          container: 'map-dom',
          style: `${process.env.MAPS_URL}/styles/${this.form.style}/style.json`,
          hash: false,
          center: this.form.center,
          zoom: this.form.zoom,
        });
        this.mapInstance.addControl(new mapboxgl.NavigationControl());
        this.mapInstance.on('move', () => {
          const c = this.mapInstance.getCenter();
          const z = this.mapInstance.getZoom();
          this.form.center = [c.lng, c.lat];
          this.form.zoom = z;
        });
      });
    },
    initPosition() {
      navigator.geolocation.getCurrentPosition((position) => {
        this.form.center = [position.coords.longitude, position.coords.latitude];
        Vue.nextTick(() => {
          this.mapInstance.setCenter(this.form.center);
        });
      });
    },
    initData() {
      this.$store.dispatch('maps/map/get_styles');
      this.$store.dispatch('maps/zones/list', { id: this.$route.params.id, user: this.user });
    },
    zoomChange(level) {
      this.mapInstance.zoomTo(level);
    },
    styleChange(style) {
      /* eslint-disable no-restricted-syntax */
      for (const s of this.mapStyles) {
        if (s.id === style) {
          fetch(s.url).then(d => d.json()).then((j) => {
            this.mapInstance.setStyle(j, { diff: false });
          });
          break;
        }
      }
    },
    onSubmit() {
      this.$validator.validateAll()
        .then((success) => {
          if (!success) {
            return;
          }
          this.$store.dispatch('maps/map/save', { mapItem: this.form, user: this.user }).then(() => {
            if (!this.mapsError) {
              this.$store.commit(`landlord/maps/${mTypes.EDIT_DATA}`, this.map);
              if (!this.$route.params.id) {
                this.$router.push({ name: 'maps', params: { id: this.map.id } });
              }
            } else {
              this.warningModalBody = this.$t('zones.save_error');
            }
          }).catch(() => {
            this.$store.commit(`maps/map/${mTypes.DATA_ERROR}`, true);
          });
          this.$validator.clean();
          this.$store.commit(`maps/map/${mTypes.DATA_ERROR}`, null);
        });
    },
  },
  data() {
    return {
      form: {
        style: 'klokantech-basic',
        center: [0, 0],
        zoom: 10,
        zones: [],
      },
      warningModalBody: null,
      mapInstance: null,
    };
  },
};
</script>
<style lang="scss" scoped>
    @import '~styles/blocks/details.scss';
    @import '~node_modules/mapbox-gl/dist/mapbox-gl.css';
    .btn {
        min-width:100%;
    }

    #map-dom {
      width: 100%;
      height: 500px;
    }

</style>



// WEBPACK FOOTER //
// src/components/maps/MapDetails.vue